'use strict';

angular.module('app.advertiserDropdownList')

.directive('advertiserDropdownListDirective', function () {
        return {
            controller: 'advertiserDropdownListCtrl',
            templateUrl: 'app/sideBarMenu/advertiserDropdownList/advertiserDropdownList.html?app_v=deployDate',
            scope: {}
        };
})